import React, { useState, useEffect, useMemo } from "react";
import Avatar from "antd/lib/avatar";
import Popover from "antd/lib/popover";
import Tooltip from "antd/lib/tooltip";
import Delete from "../../../../assets/Del_icon.svg";
import DeleteWhite from "../../../../assets/WhiteIcons/DelWhite_icon.svg";
import ReplaceIcon from "../../../../assets/replaceIcon.svg";
import edit from "../../../../assets/Edit_icon.svg";
import editWhite from "../../../../assets/Edit_iconWhite.svg";
import EditIcon from "../../../../assets/Template/Edit_icon.svg";

import editWidgetIcon from "../../../../assets/edit_widget_icon.svg";
import editFilterIcon from "../../../../assets/edit_filter_icon.svg";
import restoreWidgetIcon from "../../../../assets/restore_widget_icon.svg";

import SettingsLogo from "../../../../assets/Settings_Logo_Black.svg";
import SettingLogoHover from "../../../../assets/setting_icon_blue.svg";
import refresh from "../../../../assets/refresh.svg";
import refreshWhite from "../../../../assets/WhiteIcons/refresh_white.svg";

import Duplicate from "../../../../assets/Duplicate.svg";
import DuplicateWhite from "../../../../assets/WhiteIcons/Duplicate_white.svg";
import BuleNote from "../../../../assets/Blue_note.svg";
import GrayNote from "../../../../assets/Gray_note.svg";
import Hidden_keyword from "../../../../assets/Hidden_Keywors.svg";
import Line_chart from "../../../../assets/chartIcons/Line_chart.svg";
import area_chart from "../../../../assets/chartIcons/area_chart.svg";
import Bar_chart from "../../../../assets/chartIcons/Bar_chart.svg";

import postCard from "../../../../assets/WidgetMaker/Post_card.svg";
import postCardwhite from "../../../../assets/WidgetMaker/Post_card_white.svg";
import postCardBlue from "../../../../assets/WidgetMaker/Post_card_blue.svg";
import gridChart from "../../../../assets/WidgetMaker/grid-chart.svg";
import gridChartwhite from "../../../../assets/WidgetMaker/grid-chart-white.svg";
import gridChartBlue from "../../../../assets/WidgetMaker/grid-chart-blue.svg";

import { useDispatch, useSelector } from "react-redux";
import {
  setAddSection,
  setFilterObject,
  setTemplateFiltersObj,
  setFooterValue,
} from "../../../../redux/actions/section/section";
import EditWidget from "./editWidget";
import {
  setEditPanel,
  setTextWidgetObject,
  setTextWidgetPopupVisible,
} from "../../../../redux/actions/dashboard/dashboard";
import {
  setWidgetLibraryCheckedList,
  setWidgetLibraryFilter,
  setWidgetShow,
} from "../../../../redux/actions/WidgetMaker/WidgetLibrary.js";
import {
  setIsWidgetEdit,
  setradioArray,
  setradioChecked,
  setRemoveWordsPanelFlag,
  setFilterChange,
} from "../../../../redux/actions/Filter";
import {
  callNotification,
  getExcludedWords,
  deepCopy,
  getGlobalBrands,
  getPaneIndex,
  getWindowLocationPath,
} from "../../../../redux/constants";
import { setupdatedGraphData } from "../../../../redux/actions/widget/widget";

import uuid from "react-uuid";
import {
  setPdfEditorObject,
  setPdfEditorPanel,
} from "../../../../redux/actions/scheduleReport/scheduleReport";

import { scroller } from "react-scroll";
import isEqual from "react-fast-compare";
import SortBy from "../../../WidgetMaker/SortBy";
import AwaWidgetHeader from "./WidgetHeader/AwaWidgetHeader";
import DateAggregation from "./WidgetHeader/DateAggregation";
import WidgetHeaderFilters from "./WidgetHeader/WidgetHeaderFilters";
import WidgetHeaderEditMode from "./WidgetHeader/WidgetHeaderEditMode";
import AIinsight from "./WidgetHeader/AIinsight";
import { getProfileFilterList } from "../../../../redux/actions/ApiCall";
import WidgetDescription from "./WidgetHeader/WidgetDescription";
import CategoryOption from "./WidgetHeader/CategoryOption";
import SingleBrandsDropdown from "./WidgetHeader/SingleBrandsDropdown";
import DownloadExcel from "./WidgetHeader/DownloadExcel";
import WordCloudColorPalate from "../../../WidgetMaker/WordCloudColorPalate";
import { setEditWidget } from "../../../../redux/actions/WidgetMaker/WidgetLibrary";
import {
  setIsWidgetMakerOpenObj,
  setSaveWidgetChanges,
  setSelectedDeepdiveWidget,
} from "../../../../redux/actions/dashboard/Tab1";
import { RedoOutlined } from "@ant-design/icons";
import {
  setUpdateFiltersInWidget,
  setWidgetFetch,
} from "../../../../redux/actions/ApiCall/apiCall";
import { setY_attribute } from "../../../../redux/actions/WidgetMaker/GraphConfig";
import filterSmall from "../../../../assets/filterIcon.svg";
import filterSmallWhite from "../../../../assets/WhiteIcons/filterIconWhite.svg";
import {
  setIsNetworkWidgetSettingEdit,
  setNetworkWidgetSettingObject,
} from "../../../../redux/actions/Network";
import NetworkSettingDrawer from "../../../commandCenter/screens/Settings/NetworkSettingDrawer";
import { useHistory } from "react-router-dom";
import { getDynamicIconColor } from "../../../../redux/constants/DynamicIconColor.js";
import FilterByDropDown from "../../../shared/components/FilterByDropDown/FilterByDropDown.js";
import SaveAsBlackIcon from "../../../../assets/save_as_black_icon.svg";
import SaveAsWhiteIcon from "../../../../assets/save_as_white_icon.svg";
import { notification } from "antd";
import CountSourceToggle from "../../../utils/charts/ClusterChart/CountSourceToggle.jsx";

const WidgetHeader = ({
  graph, //graph page
  id,
  type,
  graph_type,
  data,
  section_id,
  widget_id,
  section_index,
  span,
  widget_index,
  widget_name,
  widget_description,
  widgets,
  template_widget,
  dashboard,
  datatype,
  stacked,
  desc,
  allData,
  sections,
  splitcolumns,
  chart_type,
  metaWidgetGraphData,
  note,
  widHeaderLoader,
  widgetData,
  insightsExist,
  pane_section,
  templateAccessType,
  selectedDeepdiveWidget,
}) => {
  const dispatch = useDispatch();
  const radioArray = useSelector((state) => state?.Filter?.radioArray);
  const radioChecked = useSelector((state) => state?.Filter?.radioChecked);
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const isSelected = useSelector((state) => state?.Widget?.isSelected);
  const isWidgetEdit = useSelector((state) => state?.Filter?.isWidgetEdit);
  const isNetworkWidgetSettingEdit = useSelector(
    (state) => state?.Network?.isNetworkWidgetSettingEdit
  );
  const shareBrands = useSelector((state) => state?.ApiCall?.shareBrands);
  const PdfDownloadStatus = useSelector(
    (state) => state?.PdfDownloadData?.PdfDownloadStatus
  );
  const templateObj = useSelector(
    (state) => state?.scheduleReport?.templateObj
  );
  const isPdfPreview = useSelector(
    (state) => state?.scheduleReport?.templateObj?.isPdfPreview
  );
  const totalHiddenBrandWords = useSelector(
    (state) => state?.ApiCall?.brandHiddenWords
  );
  const widgetGraphConfig = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const widgetLibrarycheckedList = useSelector(
    (state) => state?.WidgetLibrary?.widgetLibrarycheckedList
  );
  const widgetList = useSelector((state) => state?.Widget?.widgetList);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const paneindex = getPaneIndex(panes, activeKey);
  let activeGroupOrBrand =
    panes?.[paneindex]?.brands?.columns || panes?.[paneindex]?.brands;
  const [listOfBrandHiddenWords, setListOfBrandHiddenWords] = useState([]);
  const history = useHistory();
  const [replaceWidgetID, setReplaceWidgetID] = useState(null);
  let groupOrBrands = {
    groups: [],
    brands: [],
  };
  if (activeGroupOrBrand?.length > 0) {
    activeGroupOrBrand?.forEach((element) => {
      if (element.group) {
        groupOrBrands.groups.push(element.brand_friendly_name);
      } else {
        if (element.competitor) {
          element.competitorList.forEach((element) => {
            groupOrBrands.brands.push({
              brand_id: element.brand_id,
              brand_name: element.brand_friendly_name,
            });
          });
          // to insert parent element also incase its competitor dash
          groupOrBrands.brands.push({
            brand_id: element.name,
            brand_name: element.brand_friendly_name,
          });
        } else {
          groupOrBrands.brands.push({
            brand_id: element?.name || element?.brand_id,
            brand_name: element?.brand_friendly_name,
          });
        }
      }
    });
  }
  const [isSettingHovered, setSettingIsHovered] = useState(false);
  useEffect(() => {
    if (totalHiddenBrandWords && groupOrBrands) {
      let list = getExcludedWords(totalHiddenBrandWords, groupOrBrands);
      setListOfBrandHiddenWords(list);
    }
  }, []);
  const [openPopoverWidgetDesc, setOpenPopoverWidgetDesc] = useState({
    openStatus: false,
    id: null,
    view: null,
  });
  const updatedGraphData = useSelector(
    (state) => state?.Widget?.updatedGraphData
  );
  const [isDeleteModalShow, setDeleteModalShow] = useState(false);
  const [modalText, setmodalText] = useState("");

  const [activeTab, setActiveTab] = useState(widgetData?.chart?.chart_type);
  const authParams = useSelector((state) => state?.Authentication?.authParams);

  const footerValue = useSelector((state) => state?.Section?.footerValue);
  const Section = useSelector((state) => state?.Section?.addSection);

  const section1 = pane_section;
  const shareTemplateData = useSelector(
    (state) => state?.ApiCall?.shareTemplateData
  );
  const shareableLinkDeepDiveStatus = useSelector(
    (state) => state?.ApiCall?.shareableLinkDeepDiveStatus
  );
  const screen = useSelector((state) => state?.Screens?.screen);
  const isPPTModalOpen = useSelector((state) => state?.PPT?.isPPTModalOpen);

  const isScheduleReportOpen = useSelector(
    (state) => state?.ApiCall?.is_schedule_report_open
  );
  // const userPrivileges = useSelector(
  //   (state) => state?.ApiCall?.brands?.data?.result?.privileges
  // );
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );
  const highChartDeepDive = useSelector(
    (state) => state?.Highchart?.highChartDeepDive
  );

  const sectionLoader = useSelector((state) => state?.ApiCall?.sectionLoader);
  const aggregateLoader = useSelector(
    (state) => state?.apiCall?.aggregateLoader
  );
  const graphLoader = useSelector((state) => state?.apiCall?.loader); //display chart loader
  const profileLoader = useSelector((state) => state?.apiCall?.profileLoader);
  const deepdiveDashboardTemplateData = useSelector(
    (state) => state?.DeepDiveDashboard?.dashboardTemplateData
  );
  const activeTabKey = useSelector((state) => state.Tab1.activeKey);

  const section =
    !PdfDownloadStatus && sections
      ? null
      : sections && !sections?.[0]?.section_metadata && PdfDownloadStatus
      ? sections
      : section1;
  const widget_metadata =
    window.location.pathname === "/dashboard" ||
    window.location.pathname === "/pin-dashboard"
      ? section?.[section_index ? section_index : 0]?.widgets?.[widget_index]
      : Section?.[section_index ? section_index : 0]?.data?.[widget_index];
  const chart_type1 = chart_type ? chart_type : widgetData?.chart?.chart_type;
  let index = getPaneIndex(panes, activeKey);
  const [selectedChartName, setSelectedChartName] = useState(
    widgetData?.selectedChartType ? widgetData?.selectedChartType : chart_type1
  );
  let pathName = getWindowLocationPath()?.toLowerCase();
  // const templateAccessType = panes[index]?.access_type;

  useEffect(() => {
    if (
      selectedDeepdiveWidget?.section_index === section_index &&
      selectedDeepdiveWidget?.widget_index === widget_index
    ) {
      scroller.scrollTo(
        `${
          selectedDeepdiveWidget?.section_index
            ? selectedDeepdiveWidget?.section_index
            : "widget_only"
        }_${selectedDeepdiveWidget?.widget_index}`,
        {
          duration: 500,
          delay: 0,
          // smooth: true,
          offset: shareTemplateData
            ? section_index >= 0
              ? -190
              : -140
            : section_index >= 0
            ? -160
            : -100,
        }
      );
    }

    if (isSelected[id] === undefined) {
      isSelected[id] = false;
    }
    if (
      selectedDeepdiveWidget?.section_index >= 0 ||
      selectedDeepdiveWidget?.widget_index >= 0
    ) {
      dispatch(
        setSelectedDeepdiveWidget(
          null,
          null,
          panes,
          getPaneIndex(panes, activeKey)
        )
      );
    }
  }, [id]);
  useEffect(() => {
    dispatch(setupdatedGraphData({}));
  }, [widgetData?.chart?.chart_type, isScheduleReportOpen, highChartDeepDive]);

  const handleChartSwitch = (e, id) => {
    let obj = { ...updatedGraphData };
    let type = `${widgetData?.chart?.chart_type}_${id}${
      section_index >= 0 ? section_index : 0
    }${widget_index >= 0 ? widget_index : 0}`;
    obj[type] = { selected_chart: e, widgetId: id };
    dispatch(setupdatedGraphData(obj));
    setActiveTab(e);
  };

  // const handleRefresh = () => {
  //   callNotification(
  //     "Updating reach impression values, chart will refresh in sometime",
  //     "success"
  //   );
  //   let duration = panes[index]?.duration;
  //   const Globalfilters = panes[index]?.filters ? panes[index]?.filters : [];
  //   const WidgetFilters = widgetData?.filters ? widgetData?.filters : [];

  //   let global_brands =
  //     footerValue?.template &&
  //     templateDetails?.templateBrands?.columns?.length > 0
  //       ? templateDetails?.templateBrands?.columns
  //       : getGlobalBrands(
  //           panes[index]?.brands,
  //           global_dashboard_single_brands,
  //           global_dashboard_brands,
  //           panes[index]?.template_type
  //         );

  //   let twoMonthsDuration = getCustomizedDate(6, "Days");

  //   let defaultDuration = {
  //     from:
  //       moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
  //       " " +
  //       twoMonthsDuration?.time?.startTime,
  //     to:
  //       moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
  //       " " +
  //       twoMonthsDuration?.time?.endTime,
  //   };
  //   let indexes = {
  //     pane_index: index,
  //     section_index: section_index >= 0 ? section_index : null,
  //     panes: panes,
  //     widget_index: widget_index,
  //     widget_id: widgetData?.widget_id,
  //     graph_type: widgetData?.graph_type,
  //     section_id: shareTemplateData
  //       ? section_index >= 0
  //         ? shareTemplateData?.sections?.[section_index]?.section_id
  //         : shareTemplateData?.section?.[0]?.section_id
  //       : footerValue?.template
  //       ? section_index >= 0
  //         ? Section?.[section_index]?.id
  //         : Section?.[0]?.id
  //       : section_index >= 0
  //       ? panes?.[index]?.sections?.[section_index]?.section_id
  //       : panes?.[index]?.section?.[0]?.section_id,
  //   };
  //   let graphObject = {
  //     isUpdateImpression: isUpdateImpression,
  //     start_date: duration?.from
  //       ? duration?.from
  //       : widgetData?.start_date
  //       ? widgetData?.start_date
  //       : defaultDuration?.from,
  //     end_date: duration?.to
  //       ? duration?.to
  //       : widgetData?.end_date
  //       ? widgetData?.end_date
  //       : defaultDuration?.to,
  //     brands: global_brands
  //       ? global_brands
  //       : brandlogicalgroup?.length > 0
  //       ? brandlogicalgroup
  //       : brands,
  //     order_by: widgetData?.order_by,
  //     filters: [...Globalfilters, ...WidgetFilters],
  //     x_axis: widgetData?.x_axis,
  //     y_axes: widgetData?.y_axes,
  //     y_series: widgetData?.y_series,
  //     widget_name: widgetData?.widget_name,
  //     chart: widgetData?.chart,
  //     isBrandModified: global_brands ? true : false,
  //     filter_by_data: null,
  //     filter_by: null,
  //   };
  //   dispatch(callUpdateReachImpression(authParams, graphObject, indexes));

  //   let currentTime = new Date(new Date().getTime());
  //   dispatch(setReachCurrentTime(moment(currentTime).format("HH:mm")));
  // };
  const handleWidgetFilter = (widget_id, isEditor) => {
    // if (!profileFilterList?.length) {
    //   let index = getPaneIndex(panes, activeKey);

    //   let paneObject = {
    //     panes: panes,
    //     activeKey: activeKey,
    //     brands: brandlogicalgroup?.length > 0 ? brandlogicalgroup : brands,
    //     authParams: authParams,
    //     index: index,
    //     singleBrands: brands,
    //     graphConditionConfig: graphConditionConfig,
    //   };

    //   let global_brands =
    //   footerValue?.template &&
    //     templateDetails?.templateBrands?.columns?.length > 0
    //     ? templateDetails?.templateBrands?.columns
    //     : getGlobalBrands(
    //       panes[index]?.brands,
    //       global_dashboard_single_brands,
    //       global_dashboard_brands,
    //       panes[index]?.template_type
    //     );

    //   let widget_data = template_widget ?
    //     section_index >=0 && Section?.[section_index]?.data[widget_index]
    //       ? Section[section_index]?.data[widget_index] :
    //       Section?.[0]?.data[widget_index]
    //     : section_index >=0 ? panes?.[index]?.sections?.[section_index]
    //       ?.widgets?.[widget_index]
    //     : panes?.[index]?.section?.[0]?.widgets?.[widget_index]

    //   // console.log("global_brands", global_brands, "widget_data", widget_data)

    //   let profilePayload = {
    //     hidden_filter: panes[index]?.hidden_filter,
    //     quick_filter: panes[index]?.quick_filter,
    //     isBrandModified: global_brands ? true
    //       : widget_data?.is_locked ? true
    //       : widget_data?.duplicate_for_brands ? true
    //       : false,
    //     brands: widget_data?.is_locked ? widget_data?.brand_groups
    //         ? widget_data?.brand_groups : widget_data?.brand_ids
    //       : global_brands
    //       ? global_brands
    //       : brandlogicalgroup?.length > 0
    //         ? brandlogicalgroup
    //         : brands,
    //   };
    //   // console.log("profilePayload", profilePayload)

    //   dispatch(getProfileFilterList(authParams, profilePayload, paneObject));
    // }
    if (isEditor) {
      dispatch(setPdfEditorPanel(true, "addnote", templateObj));
      dispatch(
        setPdfEditorObject({
          // paneIndex: index,
          // panes: panes,
          sectionIndex: section ? null : section_index,
          widgetIndex: widget_index,
          widgetId: widget_id ? widget_id : widgets?.id,
          editorValue: data?.note && data?.note?.length > 0 ? data?.note : null,
        })
      );
    }

    dispatch(setIsWidgetEdit(true));
    let lock = widgetData?.is_locked; //check
    dispatch(
      setFilterObject(
        {
          id: widget_id ? widget_id : widgets?.id,
          type: template_widget ? "template_widget" : "widgetFilter",
          section_index: section ? null : section_index,
          widget_index: widget_index,
          onlyWidgets: section ? true : false,
          widget_chart_type: widgetData?.chart?.chart_type,
        },
        lock
      )
    );

    let obj = {
      type: template_widget ? "template_widget" : "dashboard_widget",
      section_index: section_index >= 0 ? section_index : 0,
      widget_index: widget_index,
    };
    dispatch(setEditPanel(obj));
    dispatch(
      setradioArray({
        ...radioArray,
        dashboard_widget: { data: [] },
      })
    );
    dispatch(
      setradioChecked({
        ...radioChecked,
        dashboard_widget: { data: {} },
      })
    );
  };
  const handleEditNoteWidget = (widget_id) => {
    dispatch(setTextWidgetPopupVisible(true));
    dispatch(
      setTextWidgetObject({
        section_id: section_id ? section_id : null,
        widget_id: widget_id ? widget_id : widgets?.id,
        widget_name: widgetData?.widget_name ? widgetData?.widget_name : null,
        widget_text_data: widgetData?.text ? widgetData?.text : null,
        type: template_widget ? "template_widget" : "widgetFilter",
        section_index: section ? null : section_index,
        widget_index: widget_index,
        onlyWidgets: section ? true : false,
        widget_chart_type: widgetData?.chart?.chart_type,
        isEditNoteWidget: true,
      })
    );
  };

  const handleWidgetHiddenWords = (widget_id) => {
    dispatch(setIsWidgetEdit(true));

    dispatch(
      setRemoveWordsPanelFlag({
        value: true,
        section_index: section ? null : section_index,
        widget_index: widget_index,
      })
    );
  };

  const handleWidgetNote = (widget_id) => {
    dispatch(setPdfEditorPanel(true, "addnote", templateObj));
    dispatch(
      setPdfEditorObject({
        // paneIndex: index,
        // panes: panes,
        sectionIndex: section ? null : section_index,
        widgetIndex: widget_index,
        widgetId: widget_id ? widget_id : widgets?.id,
        editorValue: data?.note && data?.note?.length > 0 ? data?.note : null,
      })
    );
  };

  const handleDuplicateWidgetFilter = (
    widget_id,
    section_index,
    widget_index,
    section_id,
    id
  ) => {
    let duplicateWidget = {};
    Section[section_index].data?.forEach((d) => {
      if (d?.widget_id === widget_id) {
        let updatedData = deepCopy(d);
        duplicateWidget = {
          ...updatedData,
          id: uuid(),
          widget_name: d?.widget_name + "- Copy",
        };
      }
    });

    let newSectionData = [...Section[section_index].data];
    newSectionData.splice(widget_index + 1, 0, duplicateWidget);

    let newSec = Section?.map((sec) => {
      if (sec.id == section_id) {
        return { ...sec, data: newSectionData };
      }
      return { ...sec };
    });

    dispatch(setAddSection(Section, newSec, "update"));
    callNotification("Widget duplicated successfully", "success");
  };

  const deleteTemse = () => {
    setmodalText("Are you sure to delete this widget?");
    setDeleteModalShow(true);
  };

  const selectedChartType = (name) => {
    setSelectedChartName(name);
    let index = getPaneIndex(panes, activeKey);
    if (shareTemplateData) {
      // share dashboard

      if (widgetData) {
        let updateShareTemplateData = { ...shareTemplateData };
        if (section_index >= 0) {
          updateShareTemplateData.sections[section_index].widgets[
            widget_index
          ].selectedChartType = name;
        } else {
          updateShareTemplateData.section[0].widgets[
            widget_index
          ].selectedChartType = name;
        }
        dispatch({
          type: "SET_SHARE_TEMPLATE_DATA",
          payload: updateShareTemplateData,
        });
      }
    } else {
      // view dashboard

      if (widgetData) {
        let updatePanes = [...panes];
        if (section_index >= 0) {
          updatePanes[index].sections[section_index].widgets[
            widget_index
          ].selectedChartType = name;
        } else {
          updatePanes[index].section[0].widgets[
            widget_index
          ].selectedChartType = name;
        }
        dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
      }
    }
  };

  // const handleRefreshAllWidget = (section_index, widget_index) => {
  //   const widgetsPayload = section_index >= 0 ?
  //     panes?.[index]?.sections?.[section_index]?.widgets?.[widget_index]
  //     : panes?.[index]?.section?.[0]?.widgets?.[widget_index]

  //   let indexes = {
  //     pane_index: index,
  //     section_index: section_index,
  //     panes: panes,
  //     widget_index: widget_index,
  //     widget_id: widget_id,
  //     graph_type: widgetsPayload?.graph_type,
  //     templateFilter: false,
  //     section_id: section_id,
  //   };

  //   let brands = {
  //     attribute: "BrandID",
  //     columns: widgetsPayload?.payload?.brand_list ? widgetsPayload?.payload?.brand_list : widgetsPayload?.payload?.brand_groups && widgetsPayload?.payload?.brand_groups,
  //     type: "varchar"
  //   }
  //   let widgetGraphObject = widgetsPayload?.payload;
  //   widgetGraphObject.brands = brands;
  //   widgetGraphObject.isBrandModified = true;
  //   authParams && dispatch(setWidgetMakerGraphData(authParams, widgetGraphObject, indexes))

  //   // conditions
  //   // if(dataSource === "ticket"){
  //   //   dispatch(setPageChart())
  //   // }else{
  //   //   dispatch(setWidgetMakerGraphData())
  //   // }
  // };

  const isDeepDiveViewOpened = useMemo(() => {
    let pathName = getWindowLocationPath()?.toLowerCase();
    return (
      (authParams?.screen_id
        ? screen?.isDeepDiveDashboard
          ? true
          : false
        : shareableLinkDeepDiveStatus
        ? shareTemplateData?.isDeepDiveDashboard
          ? true
          : false
        : !authParams?.screen_id &&
          !shareBrands &&
          (pathName === "dashboard" || pathName === "pin-dashboard") &&
          !panes?.[getPaneIndex(panes, activeKey)]?.is_widget_maker_open_obj
            ?.open_flag &&
          panes[getPaneIndex(panes, activeKey)]?.isDeepDiveDashboard
        ? true
        : false) && !deepdiveDashboardTemplateData?.isDeepDive
    );
  }, [
    screen,
    shareTemplateData,
    panes,
    authParams,
    deepdiveDashboardTemplateData,
  ]);

  let widget_comp_exclude_words = false;
  widgetData?.comp_exclude_words &&
    Array?.isArray(widgetData?.comp_exclude_words) &&
    widgetData?.comp_exclude_words?.map((d) => {
      // console.log("d", Object.keys(d)[0]);
      if (Object.keys(d)[0] == widgetData?.com_brand_ids?.[0]?.brand_id) {
        widget_comp_exclude_words = true;
      }
    });

  let wordCloudCondition = isDeepDiveViewOpened
    ? false
    : !widgetData?.childId
    ? true
    : widgetData?.childId &&
      widgetData?.comp_exclude_words &&
      widget_comp_exclude_words
    ? true
    : widgetData?.childId && widgetData?.temp_exclude_words?.length
    ? true
    : false;
  let disableReodering =
    widgetData?.childId || widgetData?.parentId ? true : false;

  const editMenu = !PdfDownloadStatus &&
    !isDeepDiveViewOpened &&
    (window.location.pathname === "/dashboard" ||
      window.location.pathname === "/pin-dashboard" ||
      window.location.pathname === "/all-dashboard") && (
      <div className="menu_edit_list">
        {/* Edit widget using widget maker */}
        <Tooltip
          title={
            ["network-graph", "network-graph-v2"]?.includes(chart_type)
              ? "Network widgets cannot be edited in Widget Maker"
              : workspace_privileges?.widget_maker?.enabled === false
              ? "You do not have activated Widget Maker access, kindly activate it first"
              : widgetData?.chart?.chart_settings?.duplicate_for_brands
              ? "Exploded widgets are not allowed to be edited"
              : widgetData?.type === "widget-maker"
              ? ""
              : "Base widgets are not allowed to be edited"
          }
        >
          <div
            className={`
              ${
                panes?.[index]?.dashboard_called_api_list?.length > 0 ||
                sectionLoader?.value ||
                graphLoader ||
                aggregateLoader ||
                profileLoader
                  ? "disable"
                  : ""
              }
              text-Darkgray font-size14 cursor-pointer align-items-center p-2 ${
                window.location.pathname === "/dashboard" ||
                window.location.pathname === "/pin-dashboard"
                  ? "d-flex"
                  : ""
              }`}
            onClick={() =>
              !["network-graph", "network-graph-v2"]?.includes(chart_type) &&
              workspace_privileges?.widget_maker?.enabled &&
              widgetData?.type === "widget-maker" &&
              !widgetData?.chart?.chart_settings?.duplicate_for_brands &&
              editWidgetByMaker(widgetData)
            }
          >
            <img
              src={
                authParams?.theme_type === "1" ? editWidgetIcon : editWidgetIcon
              }
              alt="Edit widget using widget maker"
              style={{ maxWidth: "2.2rem" }}
              className="mr-2"
            />
            Edit Widget
          </div>
        </Tooltip>
        {!panes?.[index]?.predefined && chart_type !== "text" ? (
          <Tooltip title={""}>
            <div
              className={`text-Darkgray font-size14 cursor-pointer align-items-center p-2 ${
                templateAccessType === 1 ||
                (pathName !== "all-dashboard" &&
                  pathName !== "pin-dashboard" &&
                  pathName !== "dashboard")
                  ? "d-none"
                  : ""
              }`}
              onClick={() => handleWidgetFilter(widget_id, true)}
            >
              {/* <i className="fa fa-edit cursor-pointer"></i> */}
              <Avatar
                shape="square"
                size={22}
                src={note && note?.length > 0 ? BuleNote : GrayNote}
                alt="Widget Note"
                style={{ maxWidth: "2.2rem" }}
                className="mr-2"
              />
              Add Note
            </div>
          </Tooltip>
        ) : (
          ""
        )}
      </div>
    );
  const handleSettingMouseEnter = () => {
    setSettingIsHovered(true);
  };
  const handleSettingMouseLeave = () => {
    setSettingIsHovered(false);
  };
  const handleSettingOpenToggle = () => {
    if (!isNetworkWidgetSettingEdit) {
      dispatch(
        setNetworkWidgetSettingObject({
          type: "dashboardWidgetSetting",
          sectionIndex: section ? null : section_index,
          widgetIndex: widget_index,
          onlyWidgets: section ? true : false,
          widgetId: widget_id ? widget_id : widgets?.id,
        })
      );
      if (isWidgetEdit) dispatch(setIsWidgetEdit(false));
      dispatch(setIsNetworkWidgetSettingEdit(true));
    }
  };
  const menu = !PdfDownloadStatus && !isDeepDiveViewOpened && (
    <div className="menu_edit_list">
      {/* <Menu.Item
				className="text-Darkgray font-size14 p-2"
				onClick={() => screenshot(id)}
			>
				<img
					src={download}
					alt="Download PNG"
					style={{ maxWidth: "2rem" }}
					className="mr-2"
				/>{" "}
				Download PNG
			</Menu.Item>
			<Menu.Item className="text-Darkgray font-size14 p-2">
				<img
					src={ExportinExcel}
					alt="Export in Excel"
					style={{ maxWidth: "1.8rem" }}
					className="mr-2"
				/>
				Export in Excel
			</Menu.Item> */}

      {/* Edit widget using widget maker */}
      {!widgetData?.childId &&
        !graphConditionConfig?.template_calender_action_controls?.includes(
          panes[paneindex]?.template_id
        ) &&
        (window.location.pathname === "/dashboard" ||
          window.location.pathname === "/pin-dashboard" ||
          window.location.pathname === "/all-dashboard") &&
        workspace_privileges?.edit_widget_on_dashboard_enabled && (
          <Tooltip
            title={
              ["network-graph", "network-graph-v2"]?.includes(chart_type)
                ? "Network widgets cannot be edited in Widget Maker"
                : workspace_privileges?.widget_maker?.enabled === false
                ? "You do not have activated Widget Maker access, kindly activate it first"
                : widgetData?.chart?.chart_settings?.duplicate_for_brands
                ? "Exploded widgets are not allowed to be edited"
                : widgetData?.type === "widget-maker"
                ? ""
                : "Base widgets are not allowed to be edited"
            }
          >
            <div
              className={`
                ${
                  panes?.[index]?.dashboard_called_api_list?.length > 0 ||
                  sectionLoader?.value ||
                  graphLoader ||
                  aggregateLoader ||
                  profileLoader
                    ? "disable"
                    : ""
                }
                text-Darkgray font-size14 cursor-pointer align-items-center p-2 ${
                  window.location.pathname === "/dashboard" ||
                  window.location.pathname === "/pin-dashboard"
                    ? "d-flex"
                    : ""
                }`}
              onClick={() =>
                !["network-graph", "network-graph-v2"]?.includes(chart_type) &&
                workspace_privileges?.widget_maker?.enabled &&
                widgetData?.type === "widget-maker" &&
                !widgetData?.chart?.chart_settings?.duplicate_for_brands &&
                editWidgetByMaker(widgetData)
              }
            >
              <img
                src={
                  authParams?.theme_type === "1"
                    ? editWidgetIcon
                    : editWidgetIcon
                }
                alt="Edit widget using widget maker"
                style={{ maxWidth: "2.2rem" }}
                className="mr-2"
              />
              Edit Widget
            </div>
          </Tooltip>
        )}

      {!widgetData?.childId && (
        <>
          <div
            className={`text-Darkgray font-size14 cursor-pointer  align-items-center p-2 ${
              allData?.percent ||
              templateAccessType == 1 ||
              ((window.location.pathname !== "/dashboard" ||
                window.location.pathname !== "/pin-dashboard") &&
                widget_metadata?.type === "predefined1" &&
                !widget_metadata?.supported_filters?.length)
                ? "d-none"
                : "d-flex"
            }`}
            onClick={() => handleWidgetFilter(widget_id)}
          >
            <span className="mr-2">
              {authParams?.theme_type === "1"
                ? getDynamicIconColor("edit_filter_icon_white")
                : getDynamicIconColor("edit_filter_icon")}
            </span>
            {/* <img
            src={
              authParams?.theme_type === "1" ? editFilterIcon : editFilterIcon
            }
            // src={authParams?.theme_type === "1" ? editWhite : edit}
            alt="Filter Icon"
            style={{ maxWidth: "2.2rem" }}
            className="mr-2"
          /> */}
            {/* Edit Widget */}
            Filters
          </div>
          {chart_type !== "text" ? (
            <div
              className={`text-Darkgray font-size14 cursor-pointer  align-items-center p-2 ${
                templateAccessType === 1 ||
                widgetData?.type === "x-y" ||
                (pathName !== "all-dashboard" &&
                  pathName !== "pin-dashboard" &&
                  pathName !== "dashboard")
                  ? "d-none"
                  : ""
              }`}
            >
              <span
                className="mr-2"
                onClick={() => handleWidgetFilter(widget_id, true)}
              >
                {/* <i className="fa fa-edit cursor-pointer"></i> */}
                <Avatar
                  shape="square"
                  size={22}
                  src={note && note?.length > 0 ? BuleNote : GrayNote}
                  alt="Widget Note"
                  style={{ maxWidth: "2.2rem" }}
                  className="mr-2"
                />
                Add Note
              </span>
            </div>
          ) : (
            ""
          )}
        </>
      )}

      {widgetData?.chart?.chart_type === "cluster-chart" &&
      !panes?.[index]?.predefined ? (
        <Tooltip
          placement="bottomLeft"
          title={
            panes?.[index]?.save_widget_changes?.flag
              ? ""
              : "Adjust chart styling to enable saving."
          }
        >
          <div
            className={`
              text-Darkgray font-size14 cursor-pointer  align-items-center p-2 
              ${
                templateAccessType === 1 ||
                widgetData?.type === "x-y" ||
                (pathName !== "all-dashboard" &&
                  pathName !== "pin-dashboard" &&
                  pathName !== "dashboard")
                  ? "d-none"
                  : ""
              }`}
          >
            <span
              className={`mr-2  ${
                panes?.[index]?.save_widget_changes?.flag ? "" : "disable"
              } `}
              onClick={() => handleSaveWidgetChanges(widget_id, true)}
            >
              <img
                src={
                  authParams?.theme_type === "1"
                    ? SaveAsWhiteIcon
                    : SaveAsBlackIcon
                }
                alt="Save Changes"
                style={{ maxWidth: "2.2rem" }}
                className="mr-2"
              />
              Save Changes{" "}
            </span>
          </div>
        </Tooltip>
      ) : (
        ""
      )}

      {(window.location.pathname?.split("/")?.[1] === "pin-dashboard" ||
        window.location.pathname?.split("/")?.[1] === "dashboard") &&
      ((widgetData &&
        ((!widgetData?.com_brand_ids && widgetData?.exclude_words?.length) ||
          widgetData?.temp_exclude_words?.length)) ||
        (widgetData &&
          widgetData?.comp_exclude_words?.find(
            (el) => el?.[widgetData?.com_brand_ids?.[0]?.brand_id]
          )?.[widgetData?.com_brand_ids?.[0]?.brand_id]?.length) ||
        listOfBrandHiddenWords?.length > 0) ? (
        <Tooltip
          title={
            widgetData?.is_widget_edited
              ? "Action not allowed on edited widget"
              : ""
          }
        >
          <div
            className={`text-Darkgray font-size14 cursor-pointer  align-items-center p-2 ${
              chart_type !== "wordcloud" ? "d-none" : "d-flex"
            }`}
            onClick={() =>
              !widgetData?.is_widget_edited &&
              handleWidgetHiddenWords(widget_id)
            }
          >
            <img
              src={Hidden_keyword}
              alt="Hidden words"
              style={{ maxWidth: "2.2rem" }}
              className="mr-2"
            />
            Hidden Words
          </div>
        </Tooltip>
      ) : (
        ""
      )}
      {!dashboard && !widgetData?.parentId && (
        <div
          className={`text-Darkgray font-size14 cursor-pointer d-flex align-items-center p-2 ${
            allData?.percent && "d-none"
          }`}
          onClick={() =>
            handleDuplicateWidgetFilter(
              widget_id,
              section_index,
              widget_index,
              section_id,
              id
            )
          }
        >
          <img
            src={authParams?.theme_type === "1" ? DuplicateWhite : Duplicate}
            alt="Duplicate Widget"
            style={{ maxWidth: "2rem" }}
            className="mr-2"
          />
          Duplicate Widget
        </div>
      )}
      {!dashboard && (
        <div
          className="text-Darkgray font-size14 cursor-pointer d-flex align-items-center p-2"
          onClick={() => deleteTemse()}
        >
          <img
            src={authParams?.theme_type === "1" ? DeleteWhite : Delete}
            alt="Delete Widget"
            style={{ maxWidth: "1.6rem" }}
            className="mr-2"
          />{" "}
          Delete Widget
        </div>
      )}
      {!dashboard && (
        <div
          className="text-Darkgray font-size14 cursor-pointer d-flex align-items-center p-2"
          onClick={() => handleReplaceWidget(panes[index], widget_id)}
        >
          {/* <img
            src={ReplaceIcon}
            alt="Replace Widget"
            style={{ maxWidth: "16px" }}
            className="mr-2"
          />{" "} */}
          <span className="mr-2">
            {authParams?.theme_type === "1"
              ? getDynamicIconColor("replace_icon_white")
              : getDynamicIconColor("replace_icon")}
          </span>
          Replace Widget
        </div>
      )}
    </div>
  );

  // Handle Save Widget Changes
  const handleSaveWidgetChanges = (widget_id, isEditor) => {
    let index = getPaneIndex(panes, activeTabKey);

    if (widgetData?.widget_id && authParams) {
      // If in dashboard view, update via API
      let updatedChart = widgetData?.chart;
      updatedChart.chart_settings.cluster_style =
        panes?.[index]?.save_widget_changes?.cluster_style;
      updatedChart.chart_settings.cluster_chart_type =
        panes?.[index]?.save_widget_changes?.cluster_chart_type;

      let section_id = panes?.[index]?.sections
        ? panes?.[index]?.sections?.[section_index]?.section_id
        : panes?.[index]?.section?.[0]?.section_id;

      let paneObj = {
        widget_id: widgetData?.widget_id,
        section_id: section_id,
        template_id: panes?.[index]?.template_id,
        chart: updatedChart,
        widgetMaker: widgetData?.type,
        panes: panes,
        index: index,
        section_index: section_index >= 0 ? section_index : null,
        widget_index: widget_index,
        widget_name: widgetData?.widget_name,
        activeKey: activeKey,
        updated_metadata: widgetData ? widgetData : null,
      };

      // API Call to save settings
      dispatch(
        setUpdateFiltersInWidget(
          authParams,
          widgetData?.widget_id,
          widgetData?.filters ? widgetData?.filters : [],
          paneObj,
          widgetData?.is_locked
        )
      );

      // dispatch
      let updateSaveChanges = {
        ...panes?.[index]?.save_widget_changes,
        flag: false,
      };
      dispatch(setSaveWidgetChanges(updateSaveChanges, panes, index));
    }
  };

  const handleReplaceWidget = (data, selectedWidgetID) => {
    history.push(`/dashboard`, {
      onGraphPage: true,
      section_id: id,
    });

    let widgetArray = [];
    for (let i = 0; i < data?.sections?.length; i++) {
      for (let j = 0; j < data?.sections?.[i]?.widgets?.length; j++)
        widgetArray.push(data?.sections?.[i]?.widgets?.[j]);
    }
    // For close Filter Drawer or Hidden Remove Words Drawer
    dispatch(setRemoveWordsPanelFlag(false));
    dispatch(setIsWidgetEdit(false));
    dispatch(setFilterChange(false));
    dispatch(
      setFilterObject({
        id: null,
        type: null,
        section_index: null,
        widget_index: null,
      })
    );
    dispatch(setTemplateFiltersObj(null));
    // ends here
    dispatch(
      setFooterValue({
        replaceThisWidget: selectedWidgetID,
        section: false,
        widget: false,
        template: false,
        widgetMaker: true,
      })
    );
    dispatch(setWidgetShow(false)); //to clear widget maker page state
    dispatch(setWidgetLibraryCheckedList(widgetArray));

    //   to clear persist data
    let filterObj = {
      search_text: "",
      pill: "All Widgets",
      offset: 0,
      no_of_rows: 12,
      sort_expression: "created_date",
      sort_order: "desc",
      chart_type: "",
      attribute: "",
    };
    dispatch(setWidgetLibraryFilter(filterObj));
    dispatch({ type: "SET_REPLACED_WIDGET_INDEX", payload: widget_index });
    dispatch({ type: "SET_WIDGET_LIBRARY_LIST", payload: null });
  };

  const editWidgetByMaker = (metadata) => {
    dispatch(setEditWidget(true));

    let updatePanes = [...panes];
    let widget_metadata;
    if (section_index >= 0) {
      widget_metadata =
        updatePanes[index].sections[section_index].widgets[widget_index];
    } else {
      widget_metadata = updatePanes[index].section[0].widgets[widget_index];
    }

    // console.log("Edit Widget ByMaker", { ...widget_metadata });
    let obj = {
      open_flag: true,
      section_index: section_index,
      widget_index: widget_index,
      widget_metadata: { ...widget_metadata },
    };
    dispatch(setIsWidgetMakerOpenObj(obj, panes, index));
    // Go Back to same widget
    dispatch(
      setSelectedDeepdiveWidget(section_index, widget_index, panes, index)
    );

    // Reset Widget Graph config
    dispatch(
      setY_attribute({
        x_axis: null,
        y_axis: {
          y_series_1: {
            attribute: null,
            aggregation: null,
          },
        },
        y_axis_settings: [],
        breakdown_by: [],
        filter_by: [],
        fields: [],
        chart_type: "line",
        duration: null,
        brands: null,
        filters: [],
        show_marker: true,
        card_position: "Top",
        card_limit: 5,
        card_settings: [
          {
            card_id: uuid(),
            card_name: 1,
            card_value: null,
            x_axis: null,
            y_series: null,
            response: [],
          },
        ],
        rich_fields_content: null,
        chart_settings: {
          global_data_label: false,
          show_details_on_card: false,
          is_stacked: true,
          data_count_card: true,
          duration_comparison: false, // This is used for only KPI
          show_previous_duration_comparison: false, // This is used for charts
          show_previous_duration_data: false, // This is used for charts
          show_as_median: false, // this is used for scatter chart
          card_percent: true,
          chart_percent: false,
          gradient_color: false,
          group_line_agg: null,
          benchmark_line: false,
          benchmark_static_value: null,
          duplicate_for_brands: false,
          split_cards: true,
          wordcloud_color: "0",
          top_posts_in_cards: false,
          show_header: true,
          show_peak: true,
          show_valley: true,
          chart_styles: null,
          cluster_chart_type: null,
          cluster_style: null,
        },
        chart_property: {
          chart_name: widgetGraphConfig?.chart_property?.chart_name,
          legend_position: "bottom",
          y_axis_mode: 2,
          no_of_top_posts: 1,
        },
        widget_description: widgetGraphConfig?.widget_description,
        dragDataType: {
          varchar: false,
          int: false,
          datetime: false,
          json: false,
        },
        edit_fields: {
          boolValue: false,
          series: "",
          data: "",
        },
        order_by: null,
        custom_attribute: {
          name: null,
          description: null,
          formula: null,
          custom_column: [
            {
              parameters: {
                attribute: null,
                display_name: null,
                data_type: null,
                selected: true,
              },
              operator: { value: null, selected: false },
              pair: {
                parameters: {
                  attribute: null,
                  display_name: null,
                  data_type: null,
                  selected: false,
                },
                numeric: { value: null, selected: false },
              },
              combined_operator: {
                value: null,
                selected: false,
              },
            },
          ],
        },
        widgetResetState: true,
        tags: widgetGraphConfig?.tags,
        filter_by_data: [],
        postcard_pills_filter: null,
        // for filter dropdown in widget header
        filter_dropdown: [],
        filter_by_dropdown: [],
        filter_by_dropdown_data: [],
        multilevel_breakdown: null,
      })
    );
  };

  const restroreWidget = (widget_metadata) => {
    let updatePanes = [...panes];
    if (section_index >= 0) {
      // updatePanes[index].sections[section_index].widgets[
      //   widget_index
      // ].graphData = null;

      // updatePanes[index].sections[section_index].widgets[
      //   widget_index
      // ].persist_graphdata = null;

      // updatePanes[index].sections[section_index].widgets[
      //   widget_index
      // ].deep_dive_on = null;

      updatePanes[index].sections[section_index].widgets[
        widget_index
      ].is_widget_edited = null;

      let obj = {
        open_flag: false,
        section_index: null,
        widget_index: null,
      };
      updatePanes[index].is_widget_maker_open_obj = obj;

      // If no widget edited, then false
      let is_widget_edited;
      updatePanes[index].sections?.map((sec) => {
        sec?.widgets?.map((wid) => {
          if (wid?.is_widget_edited) {
            is_widget_edited = true;
          }
        });
      });

      // console.log("is_widget_edited", is_widget_edited);
      if (is_widget_edited) {
        updatePanes[index].is_dashboard_edited = true;
      } else {
        updatePanes[index].is_dashboard_edited = false;
      }
    } else {
      // updatePanes[index].section[0].widgets[widget_index].graphData = null;
      // updatePanes[index].section[0].widgets[widget_index].persist_graphdata =
      //   null;
      // updatePanes[index].section[0].widgets[widget_index].deep_dive_on = null;
      updatePanes[index].section[0].widgets[widget_index].is_widget_edited =
        null;

      let obj = {
        open_flag: false,
        section_index: null,
        widget_index: null,
      };
      updatePanes[index].is_widget_maker_open_obj = obj;

      // If no widget edited, then false
      let is_widget_edited;
      updatePanes[index].section[0].widgets?.map((wid) => {
        if (wid?.is_widget_edited) {
          is_widget_edited = true;
        }
      });

      // console.log("is_widget_edited", is_widget_edited);
      if (is_widget_edited) {
        updatePanes[index].is_dashboard_edited = true;
      } else {
        updatePanes[index].is_dashboard_edited = false;
      }
    }
    // console.log("updatePanes", updatePanes);
    // dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });

    // console.log(
    //   "Inside restroreWidget",
    //   widget_metadata,
    //   "panes",
    //   panes[index],
    //   "section_id",
    //   section_id
    // );
    let paneObj = {
      section_id: section_id,
      template_id: updatePanes?.[index]?.template_id,
      widget_id: widget_metadata?.widget_id,
      revert_widget: true,
      section_index: section_index,
      widget_index: widget_index,
      panes: updatePanes,
      index: index,
    };
    dispatch(setWidgetFetch(authParams, paneObj));
  };
  const templateId = useMemo(() => {
    if (panes?.[index]?.template_id) {
      return panes?.[index]?.template_id;
    }
    return null;
  }, [panes?.[index]]);
  const isChildViewOfGridPresent = useMemo(() => {
    if (chart_type === "pivot-grid" || chart_type === "grid") {
      if (
        metaWidgetGraphData?.[0]?.columns &&
        Array.isArray(metaWidgetGraphData?.[0]?.columns)
      ) {
        // Check if any column has children
        const hasChildren = metaWidgetGraphData?.[0]?.columns?.some(
          (col) => col?.children?.length
        );
        if (hasChildren) return hasChildren;
      }
    }
    return false;
  }, [metaWidgetGraphData, chart_type]);
  return (
    <>
      {isWidgetEdit && widgets && (
        <EditWidget graph_type={graph_type} section_index={section_index} />
      )}
      {isNetworkWidgetSettingEdit && widgets ? <NetworkSettingDrawer /> : ""}
      {graph ? (
        <AwaWidgetHeader
          id={id}
          type={type}
          graph_type={graph_type}
          section_index={section_index}
          span={span}
          widget_index={widget_index}
          widget_name={widget_name}
          datatype={datatype}
          stacked={stacked}
          desc={desc}
          allData={allData}
          sections={sections}
          splitcolumns={splitcolumns}
          chart_type={chart_type}
          widHeaderLoader={widHeaderLoader}
          widgetData={widgetData}
        />
      ) : (
        <div className="p-10 border-bottom border-color">
          <div
            className={`  d-flex justify-content-between align-items-center ${
              widHeaderLoader ? " disable" : ""
            } `}
            id={
              selectedDeepdiveWidget?.section_index === section_index &&
              selectedDeepdiveWidget?.widget_index === widget_index
                ? `${
                    section_index ? section_index : "widget_only"
                  }_${widget_index}`
                : ""
            }
            style={{ minHeight: "4.1rem" }}
          >
            <div className="portlet__title fontSize-16 font-weight500 w-100">
              {footerValue?.template ? (
                <WidgetHeaderEditMode
                  section_index={section_index}
                  widget_index={widget_index}
                  widget_name={widget_name}
                  sections={sections}
                  widgetData={widgetData}
                  widget_id={widget_id}
                  section_id={section_id}
                  modalText={modalText}
                  setDeleteModalShow={setDeleteModalShow}
                  isDeleteModalShow={isDeleteModalShow}
                  setOpenPopoverWidgetDesc={setOpenPopoverWidgetDesc}
                  openPopoverWidgetDesc={openPopoverWidgetDesc}
                  disableReodering={disableReodering}
                />
              ) : (
                <>
                  {widget_id === "000-700-001" ? (
                    <Tooltip title="This widget gets refreshed in every 1 minutes.">
                      <span
                        className="agent_widget_circle cursor-pointer mr-1"
                        //style={{ color: "#A020F0" }}
                      />
                    </Tooltip>
                  ) : (
                    ""
                  )}
                  {widget_name}
                  {/* {window.location.pathname === "/dashboard" &&
                    widgetData?.graph_type === "prolific-user" && (
                      <Tooltip title="This widget supports only Sentiment and Verified filters">
                        <i
                          className="fa fa-info-circle cursor-pointer"
                          style={{
                            color:
                              authParams?.theme_type === "1"
                                ? "#fff"
                                : "#3b5175",
                            margin: "0.5rem",
                          }}
                        />
                      </Tooltip>
                    )} */}
                  {((Section &&
                    Section?.[section_index ? section_index : 0]?.data?.[
                      widget_index
                    ]?.type === "predefined") ||
                    (sections &&
                      sections?.[section_index ? section_index : 0]?.widgets?.[
                        widget_index
                      ]?.type === "predefined") ||
                    widgetData?.type === "predefined") &&
                    widget_id !== "000-700-001" && (
                      <Tooltip title="This is a predefined widget and does not support mention level filters">
                        <span
                          className="predefined_widget_circle cursor-pointer ml-1"
                          //style={{ color: "#A020F0" }}
                        />
                      </Tooltip>
                    )}
                  {widgetData?.widget_description &&
                    !isPdfPreview &&
                    !isScheduleReportOpen &&
                    !isPPTModalOpen &&
                    !PdfDownloadStatus &&
                    widgetData?.widget_description_on_icon && (
                      <Tooltip
                        // title={widgetData?.widget_description}
                        title={
                          <div
                            className="custom_scroll"
                            style={{
                              maxWidth: "270px",
                              maxHeight: "220px",
                              overflow: "auto",
                              scrollBehavior: "smooth",
                            }}
                          >
                            <div className="mb-1">
                              {widgetData?.widget_description}
                            </div>
                          </div>
                        }
                        placement="bottom"
                      >
                        <i
                          className="fa fa-info-circle text-gray cursor-pointer ml-1"
                          //style={{ color: "#A020F0" }}
                        />
                      </Tooltip>
                    )}

                  {(chart_type === "pivot-grid" || chart_type === "grid") &&
                  metaWidgetGraphData &&
                  metaWidgetGraphData[0]?.dataSource ? (
                    templateId === "000-000-242" &&
                    metaWidgetGraphData[0]?.dataSource?.length > 7 ? (
                      <span className="text-gray ml-1">( Showing Top 7 )</span>
                    ) : insightsExist && note ? (
                      metaWidgetGraphData[0]?.dataSource?.length > 8 && (
                        <span className="text-gray ml-1">
                          ( Showing Top 8 )
                        </span>
                      )
                    ) : isChildViewOfGridPresent &&
                      metaWidgetGraphData[0]?.dataSource?.length > 9 ? (
                      <span className="text-gray ml-1">(Showing Top 9)</span>
                    ) : (
                      metaWidgetGraphData[0]?.dataSource?.length > 11 && (
                        <span className="text-gray ml-1">(Showing Top 11)</span>
                      )
                    )
                  ) : (
                    ""
                  )}
                  {(chart_type === "post-card" ||
                    chart_type === "survey-card" ||
                    chart_type === "review-card") &&
                  metaWidgetGraphData &&
                  metaWidgetGraphData[0]?.data &&
                  metaWidgetGraphData[0]?.data?.length > 6 &&
                  !note ? (
                    <span className="text-gray ml-1">( Showing Top 6 )</span>
                  ) : (
                    (chart_type === "post-card" ||
                      chart_type === "survey-card" ||
                      chart_type === "review-card") &&
                    metaWidgetGraphData &&
                    metaWidgetGraphData[0]?.data &&
                    metaWidgetGraphData[0]?.data?.length > 3 &&
                    note && (
                      <span className="text-gray ml-1">( Showing Top 3 )</span>
                    )
                  )}

                  {chart_type === "author-card" &&
                  metaWidgetGraphData &&
                  metaWidgetGraphData[0]?.data &&
                  metaWidgetGraphData[0]?.data?.length > 9 &&
                  !note ? (
                    <span className="text-gray ml-1">( Showing Top 9 )</span>
                  ) : (
                    chart_type === "author-card" &&
                    metaWidgetGraphData &&
                    metaWidgetGraphData[0]?.data &&
                    metaWidgetGraphData[0]?.data?.length > 6 &&
                    note && (
                      <span className="text-gray ml-1">( Showing Top 6 )</span>
                    )
                  )}
                </>
              )}
            </div>
            {/* Chart Switching Start */}
            {(widgetData?.chart?.chart_type === "line" ||
              widgetData?.chart?.chart_type === "bar" ||
              widgetData?.chart?.chart_type === "area") &&
            !widgetData?.chart?.chart_settings?.show_3d &&
            widgetData?.type !== "predefined" &&
            !widgetData?.chart?.chart_settings?.chart_percent &&
            !(typeof widgetData?.graphData === "string") &&
            !isPdfPreview &&
            !isScheduleReportOpen &&
            !isPPTModalOpen &&
            !PdfDownloadStatus &&
            (window.location.pathname?.split("/")?.[1] === "dashboard" ||
              window.location.pathname?.split("/")?.[1] === "pin-dashboard" ||
              window.location.pathname?.split("/")?.[1] === "share") &&
            !widgetData?.graphData?.data?.[`${activeTab}`]?.[0]?.y_axis
              ?.length ? (
              <div className="ChartType">
                <Tooltip title="Bar Chart" placement="bottom">
                  <img
                    src={Bar_chart}
                    className={`mr-1  ChartType-list ${
                      activeTab === "bar" && "active"
                    } ${allData?.percent && "d-none"}`}
                    onClick={() => handleChartSwitch("bar", widget_id)}
                    alt="Bar Chart"
                    style={{ cursor: "pointer" }}
                  />
                </Tooltip>
                <Tooltip title="Area Chart" placement="bottom">
                  <img
                    src={area_chart}
                    className={`mr-1  ChartType-list ${
                      activeTab === "area" && "active"
                    } ${allData?.percent && "d-none"}`}
                    onClick={() => handleChartSwitch("area", widget_id)}
                    alt="Bar Chart"
                    style={{ cursor: "pointer" }}
                  />
                </Tooltip>
                <Tooltip title="Line Chart" placement="bottom">
                  <img
                    src={Line_chart}
                    className={`mr-1  ChartType-list ${
                      activeTab === "line" && "active"
                    } ${allData?.percent && "d-none"}`}
                    onClick={() => handleChartSwitch("line", widget_id)}
                    alt="Line Chart"
                    style={{ cursor: "pointer" }}
                  />
                </Tooltip>
              </div>
            ) : (
              ""
            )}
            {/* Chart Switching End */}
            {workspace_privileges?.ai_insights_enabled &&
              !isDeepDiveViewOpened &&
              !isPdfPreview &&
              !isScheduleReportOpen &&
              !isPPTModalOpen &&
              !PdfDownloadStatus &&
              ((![
                "author-card",
                "map",
                "review-card",
                "prolific-user",
                "post-card",
                "survey-card",
                "kpi",
                "sunburst",
                "bubble",
                "aggregate",
                "text",
                "media",
                "network-graph",
                "network-graph-v2",
              ]?.includes(chart_type) &&
                allData &&
                widgetData?.type !== "predefined" &&
                window.location.pathname === "/dashboard") ||
                ((window.location.pathname === "/schedule" ||
                  isScheduleReportOpen) &&
                  metaWidgetGraphData &&
                  ![
                    "author-card",
                    "map",
                    "review-card",
                    "prolific-user",
                    "post-card",
                    "survey-card",
                    "kpi",
                    "sunburst",
                    "bubble",
                    "aggregate",
                    "text",
                    "media",
                    "network-graph",
                    "network-graph-v2",
                  ]?.includes(chart_type))) && (
                <AIinsight
                  section_index={section_index}
                  widget_index={widget_index}
                  allData={allData}
                  sections={sections}
                  chart_type={chart_type}
                  metaWidgetGraphData={metaWidgetGraphData}
                  widgetData={widgetData}
                />
              )}

            {/* Edit Widget Using Widget Maker */}
            {/* {panes?.[index]?.template_type !== "ticket" &&
            (window.location.pathname === "/dashboard" ||
              window.location.pathname === "/all-dashboard" ||
              window.location.pathname === "/pin-dashboard") ? (
              <div
                className="text-Darkgray font-size14 cursor-pointer align-items-center"
                onClick={() => editWidgetByMaker(widgetData)}
              >
                <Tooltip title="Edit widget using widget maker">
                  <img
                    src={
                      authParams?.theme_type === "1"
                        ? editWhite
                        : editWidgetIcon
                    }
                    alt="Edit Widget in Widget Maker"
                    style={{ maxWidth: "2.2rem" }}
                    className="mr-2"
                  />
                </Tooltip>
              </div>
            ) : (
              ""
            )} */}
            {["network-graph", "network-graph-v2"]?.includes(chart_type) ? (
              <div className="portlet__title--secondary fontSize-14 ml-2 mr-2  no--wrap">
                <span class="error">*</span>Double Click on node to deep dive
                analysis.
              </div>
            ) : (
              ""
            )}
            {/* For Cluster Chart, Total Count Mode */}
            {!isPdfPreview &&
              !isScheduleReportOpen &&
              !isPPTModalOpen &&
              !PdfDownloadStatus &&
              typeof widgets !== "string" &&
              widgetData?.chart?.chart_type === "cluster-chart" &&
              (window.location.pathname === "/dashboard" ||
                window.location.pathname === "/pin-dashboard" ||
                window.location.pathname === "/share") && (
                <CountSourceToggle
                  section_index={section_index}
                  widget_index={widget_index}
                />
              )}

            {!isPdfPreview &&
              !isScheduleReportOpen &&
              !isPPTModalOpen &&
              !PdfDownloadStatus &&
              (typeof widgets === "string"
                ? typeof widgets === "string"
                  ? false
                  : true
                : true) &&
              (widgetData?.chart?.chart_type === "wordcloud" ||
                widgetData?.chart?.chart_type === "network-graph") && (
                <WordCloudColorPalate
                  section_index={section_index}
                  widget_index={widget_index}
                  widgetData={widgetData}
                  template_widget={template_widget}
                  type="dashboard"
                />
              )}

            {/* {Filter DropDown} */}
            {!isPdfPreview &&
              !isScheduleReportOpen &&
              !isPPTModalOpen &&
              !PdfDownloadStatus &&
              (typeof widgets === "string"
                ? typeof widgets === "string"
                  ? widgetData?.quickFilterDropdownListInNoData &&
                    Array.isArray(widgetData?.quickFilterDropdownListInNoData)
                    ? true
                    : false
                  : true
                : true) && (
                <FilterByDropDown
                  section_index={section_index}
                  widget_index={widget_index}
                  metadata={widgetData}
                  template_widget={template_widget}
                  type="dashboard"
                />
              )}

            {/* Post to Grid */}
            {/* {!isPdfPreview &&
              !isScheduleReportOpen &&
              !isPPTModalOpen &&
              !PdfDownloadStatus &&
              !["edit-dashboard", "create-dashboard"]?.includes(
                getWindowLocationPath()
              ) &&
              ["post-card"]?.includes(chart_type1) &&
              typeof widgetData?.graphData !== "string" && (
                <>
                  <div className={`d-flex align-items-center chartTypeList`}>
                    <Tooltip
                      title={
                        <div className="text-transform__capitalize">
                          Post Card
                        </div>
                      }
                      placement="top"
                    >
                      <div
                        className={`cursor-pointer border-radius-4 WidgetFilter_title pt-0 pb-0 border ${
                          selectedChartName === "post-card"
                            ? "border-blue"
                            : "border-color"
                        } mr-1 mb-0`}
                        onClick={() => selectedChartType("post-card")}
                        key={"Toggle_ChartType_1"}
                      >
                        <img
                          src={
                            selectedChartName === "post-card"
                              ? postCardBlue
                              : authParams?.theme_type === "1"
                              ? postCardwhite
                              : postCard
                          }
                          style={{ maxWidth: "2.1rem" }}
                          alt="chart icon"
                        />
                      </div>
                    </Tooltip>
                    <Tooltip
                      title={
                        <div className="text-transform__capitalize">Grid</div>
                      }
                      placement="top"
                    >
                      <div
                        className={`cursor-pointer border-radius-4 WidgetFilter_title pt-0 pb-0 border ${
                          selectedChartName === "grid"
                            ? "border-blue"
                            : "border-color"
                        } mr-1 mb-0`}
                        onClick={() => selectedChartType("grid")}
                        key={"Toggle_ChartType_2"}
                      >
                        <img
                          src={
                            selectedChartName === "grid"
                              ? gridChartBlue
                              : authParams?.theme_type === "1"
                              ? gridChartwhite
                              : gridChart
                          }
                          style={{ maxWidth: "2.1rem" }}
                          alt="chart icon"
                        />
                      </div>
                    </Tooltip>
                  </div>
                </>
              )} */}

            {!isPdfPreview &&
              !isScheduleReportOpen &&
              !isPPTModalOpen &&
              !PdfDownloadStatus &&
              [
                "post-card",
                "review-card",
                "author-card",
                "prolific-user",
                "news-card",
              ]?.includes(chart_type1) &&
              typeof widgetData?.graphData !== "string" && (
                <SortBy
                  filterPills={
                    widgetData?.graphData
                      ? widgetData?.graphData?.data?.[
                          chart_type1 === "horizontal-bar" ? "bar" : chart_type1
                        ]?.[0]?.["filter-pills"]
                      : widgetData?.data?.data?.[
                          chart_type1 === "horizontal-bar" ? "bar" : chart_type1
                        ]?.[0]?.["filter-pills"]
                  }
                  metadata={widgetData}
                  section_index={section_index}
                  widget_index={widget_index}
                  // dashboard={dashboard}
                  PdfDownloadStatus={isPdfPreview || PdfDownloadStatus}
                  PptGeneratingStatus={isPPTModalOpen ? isPPTModalOpen : false}
                  widget_id={widget_id}
                  chart_type={chart_type1}
                  dashboard={true}
                />
              )}
            {/* {window.location.pathname !== "/share" && allData?.refresh_ri && (
            <Tooltip
              placement="left"
              title={
                refreshTime > reachCurrentTime
                  ? `Button is disabled until ${refreshTime}`
                  : "Refresh reach impression values"
              }
            >
              <Button
                disabled={refreshTime > reachCurrentTime ? true : false}
                onClick={handleRefresh}
                className={
                  refreshTime > reachCurrentTime
                    ? "btn_Clear-disable"
                    : "mr-2 ml-2 btn_Clear"
                }
              >
                <SyncOutlined
                  style={{
                    fontSize: "1.6rem",
                    color: authParams?.theme_type === "1" ? "#fff" : "#343a40",
                    fontWeight: 700,
                  }}
                />
              </Button>
            </Tooltip>
          )} */}

            {widgetData?.y_series?.[0]?.attribute === "roi_workflow"
              ? ""
              : !isPdfPreview &&
                !isScheduleReportOpen &&
                !isPPTModalOpen &&
                !PdfDownloadStatus &&
                (typeof widgets === "string"
                  ? typeof widgets === "string"
                    ? false
                    : true
                  : true) &&
                (widgetData?.chart?.chart_type === "grid" ||
                  widgetData?.chart?.chart_type === "kpi" ||
                  widgetData?.graphData?.data?.kpi?.length > 0 ||
                  widgetData?.chart?.chart_type === "pivot-grid") && (
                  <DownloadExcel widgetData={widgetData} />
                )}

            {!isPdfPreview &&
              !isScheduleReportOpen &&
              !isPPTModalOpen &&
              !PdfDownloadStatus &&
              ((graphConditionConfig &&
                ((graphConditionConfig?.["date-attributes"]?.includes(
                  widgetData?.x_axis?.attribute
                ) &&
                  (!widgetData?.x_axis?.date_part ||
                    widgetData?.x_axis?.date_part === "D")) ||
                  widgetData?.y_axes?.some(
                    (y_axis) =>
                      graphConditionConfig?.["date-attributes"]?.includes(
                        y_axis?.attribute
                      ) &&
                      (!y_axis?.date_part || y_axis?.date_part === "D")
                  )) &&
                widgetData?.data_source === "ticket" &&
                widgetData?.chart?.chart_type === "grid") ||
                (graphConditionConfig &&
                  ((graphConditionConfig?.["date-attributes"]?.includes(
                    widgetData?.x_axis?.attribute
                  ) &&
                    (!widgetData?.x_axis?.date_part ||
                      widgetData?.x_axis?.date_part === "D")) ||
                    widgetData?.y_axes?.some(
                      (y_axis) =>
                        graphConditionConfig?.["date-attributes"]?.includes(
                          y_axis?.attribute
                        ) &&
                        (!y_axis?.date_part || y_axis?.date_part === "D")
                    )) &&
                  graphConditionConfig?.["date_agg-chart_type"]?.includes(
                    widgetData?.chart?.chart_type
                  ) &&
                  widgetData)) &&
              (typeof widgetData?.data === "object" ||
                typeof widgetData?.graphData === "object") && (
                <DateAggregation
                  section_index={section_index}
                  widget_index={widget_index}
                  widgetData={widgetData}
                  template_widget={template_widget}
                />
              )}
            {!isDeepDiveViewOpened &&
              !isPdfPreview &&
              !isScheduleReportOpen &&
              !isPPTModalOpen &&
              !PdfDownloadStatus &&
              (typeof widgets === "string"
                ? typeof widgets === "string" &&
                  !widgetData?.widgetSingleBrandFilter
                  ? false
                  : true
                : true) &&
              graphConditionConfig &&
              graphConditionConfig?.["realtime_widget-brand_filter"]?.includes(
                widgetData?.widget_id
              ) && (
                <SingleBrandsDropdown
                  section_index={section_index}
                  widget_index={widget_index}
                  widgetData={widgetData}
                  template_widget={template_widget}
                />
              )}
            {!isDeepDiveViewOpened &&
              !isPdfPreview &&
              !isScheduleReportOpen &&
              !isPPTModalOpen &&
              !PdfDownloadStatus &&
              widgetData?.widget_id ===
                graphConditionConfig?.[`realtime_widget-category_filter`] && (
                <CategoryOption
                  section_index={section_index}
                  widget_index={widget_index}
                  widgetData={widgetData}
                  template_widget={template_widget}
                />
              )}

            {/* <Tooltip title="Refresh">
            <Button
              // disabled={refreshTime > reachCurrentTime ? true : false}
              onClick={() => handleRefreshAllWidget(section_index, widget_index)}
              className={
                refreshTime > reachCurrentTime
                  ? "btn_Clear-disable ml-2"
                  : "btn_Clear ml-2"
              }
            >
              <img
                src={
                  authParams?.theme_type === "1"
                    ? refreshWhite
                    : refresh
                }
                alt="refresh"
                style={{ maxHeight: "1.5rem" }}
              />
            </Button>
          </Tooltip> */}

            {/* {console.log("header widgetData", widgetData)} */}
            {/* Revert to old widget */}
            {widgetData?.type === "widget-maker" &&
            (window.location.pathname === "/dashboard" ||
              window.location.pathname === "/all-dashboard" ||
              window.location.pathname === "/pin-dashboard") &&
            widgetData?.is_widget_edited ? (
              <div
                className="text-Darkgray font-size14 cursor-pointer align-items-center ml-2"
                onClick={() => restroreWidget(widgetData)}
              >
                <Tooltip title="Restore to original widget" placement="topLeft">
                  <img
                    src={
                      authParams?.theme_type === "1"
                        ? restoreWidgetIcon
                        : restoreWidgetIcon
                    }
                    alt="Edit Widget in Widget Maker"
                    style={{ maxWidth: "2.2rem" }}
                    // className="mr-2"
                  />
                </Tooltip>
              </div>
            ) : (
              ""
            )}
            {!graphConditionConfig?.template_calender_action_controls?.includes(
              panes[paneindex]?.template_id
            ) || isDeepDiveViewOpened ? (
              <div className="d-flex align-items-center">
                {(window.location.pathname?.split("/")?.[1] ===
                  "create-dashboard" ||
                  window.location.pathname?.split("/")?.[1] ===
                    "edit-dashboard") &&
                  widgetData?.data_source === "ticket" && (
                    <Tooltip
                      className="ml-2"
                      placement="left"
                      title="You can only view data for the first selected brand in this widget."
                    >
                      <i
                        className="fa fa-exclamation-circle cursor-pointer"
                        style={{ color: "#deaa0c" }}
                      />
                    </Tooltip>
                  )}
                {!isPdfPreview &&
                  !isScheduleReportOpen &&
                  !isPPTModalOpen &&
                  !PdfDownloadStatus && (
                    <WidgetHeaderFilters
                      section_index={section_index}
                      widget_index={widget_index}
                      sections={sections}
                      widgetData={widgetData}
                      dashboard={dashboard}
                      data={data}
                    />
                  )}
                {["network-graph", "network-graph-v2"]?.includes(chart_type) ? (
                  <img
                    className="Screen__icons--settings cursor-pointer ml-2"
                    src={
                      isSettingHovered || isNetworkWidgetSettingEdit
                        ? SettingLogoHover
                        : SettingsLogo
                    }
                    onMouseEnter={handleSettingMouseEnter}
                    onMouseLeave={handleSettingMouseLeave}
                    onClick={handleSettingOpenToggle}
                  />
                ) : (
                  ""
                )}

                <div
                  className={`portlet__title ml-2 fontSize-14 ${
                    (isWidgetEdit ||
                      shareBrands ||
                      (PdfDownloadStatus && !isPdfPreview)) &&
                    "d-none"
                  }`}
                >
                  {widgetData?.chart?.chart_type === "text" &&
                  ["edit-dashboard", "create-dashboard"]?.includes(
                    getWindowLocationPath()
                  ) ? (
                    <div className="d-flex">
                      <img
                        src={
                          authParams?.theme_type === "1" ? DeleteWhite : Delete
                        }
                        alt="Delete Widget"
                        style={{ maxWidth: "1.6rem" }}
                        className="mr-2 cursor-pointer"
                        onClick={() => deleteTemse()}
                      />{" "}
                      <img
                        src={EditIcon}
                        alt="edit_icon"
                        className={`mr-2 cursor-pointer`}
                        style={{ width: "1.8rem" }}
                        onClick={() => handleEditNoteWidget(widget_id)}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {isDeepDiveViewOpened ? (
                    ""
                  ) : chart_type === "wordcloud" &&
                    (PdfDownloadStatus ||
                      templateAccessType == 1 ||
                      ((window.location.pathname === "/dashboard" ||
                        window.location.pathname === "/pin-dashboard") &&
                        allData?.percent)) &&
                    !isScheduleReportOpen ? (
                    (widgetData &&
                      ((!widgetData?.com_brand_ids &&
                        widgetData?.exclude_words?.length) ||
                        widgetData?.temp_exclude_words?.length)) ||
                    (widgetData &&
                      widgetData?.comp_exclude_words?.find(
                        (el) => el?.[widgetData?.com_brand_ids?.[0]?.brand_id]
                      )?.[widgetData?.com_brand_ids?.[0]?.brand_id]?.length) ||
                    listOfBrandHiddenWords?.length > 0 ? (
                      <Popover
                        content={menu}
                        placement="bottomRight"
                        overlayClassName={
                          authParams?.theme_type === "1"
                            ? "darkTheme"
                            : "lightTheme"
                        }
                      >
                        <span
                          className="ant-dropdown-link fontSize-18 cursor-pointer"
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fa fa-ellipsis-h cursor-pointer"></i>{" "}
                        </span>
                      </Popover>
                    ) : (
                      ""
                    )
                  ) : (PdfDownloadStatus ||
                      templateAccessType == 1 ||
                      (widgetData?.chart?.chart_type === "text" &&
                        !isPdfPreview) ||
                      ((window.location.pathname === "/dashboard" ||
                        window.location.pathname === "/pin-dashboard") &&
                        allData?.percent)) &&
                    workspace_privileges?.edit_widget_on_dashboard_enabled ? (
                    <Popover
                      content={editMenu}
                      placement="bottomRight"
                      overlayClassName={
                        authParams?.theme_type === "1"
                          ? "darkTheme"
                          : "lightTheme"
                      }
                    >
                      <span
                        className="ant-dropdown-link fontSize-18 cursor-pointer"
                        onClick={(e) => e.preventDefault()}
                      >
                        <i className="fa fa-ellipsis-h cursor-pointer" />
                      </span>
                    </Popover>
                  ) : (PdfDownloadStatus ||
                      templateAccessType == 1 ||
                      widgetData?.chart?.chart_type === "text" ||
                      ((window.location.pathname === "/dashboard" ||
                        window.location.pathname === "/pin-dashboard") &&
                        allData?.percent)) &&
                    !workspace_privileges?.edit_widget_on_dashboard_enabled ? (
                    ""
                  ) : (
                    !isScheduleReportOpen &&
                    wordCloudCondition && (
                      <Popover
                        content={menu}
                        placement="bottomRight"
                        overlayClassName={
                          authParams?.theme_type === "1"
                            ? "darkTheme"
                            : "lightTheme"
                        }
                      >
                        <span
                          className="ant-dropdown-link fontSize-18 cursor-pointer"
                          onClick={(e) => e.preventDefault()}
                        >
                          <i className="fa fa-ellipsis-h cursor-pointer" />
                        </span>
                      </Popover>
                    )
                  )}
                  {isPdfPreview && chart_type !== "text" && (
                    <Tooltip title={"Note"}>
                      <span
                        className="ant-dropdown-link fontSize-18 cursor-pointer ml-10"
                        onClick={() => handleWidgetNote(widget_id)}
                      >
                        {/* <i className="fa fa-edit cursor-pointer"></i> */}

                        <Avatar
                          shape="square"
                          size={22}
                          src={note && note?.length > 0 ? BuleNote : GrayNote}
                          alt="Widget Note"
                        />
                      </span>
                    </Tooltip>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>

          {widgetData?.widget_description &&
            (!widgetData?.widget_description_on_icon ||
              isPdfPreview ||
              isScheduleReportOpen ||
              isPPTModalOpen ||
              PdfDownloadStatus) && (
              <div
                className={` w-100 fontSize-14 text_regular-gray text-wrap break-all font-weight400 contenteditable_description ${
                  openPopoverWidgetDesc?.openStatus ? "show_editable_icon" : ""
                } `}
              >
                {widgetData?.widget_description}
                {(window.location.pathname?.split("/")?.[1] ===
                  "create-dashboard" ||
                  window.location.pathname?.split("/")?.[1] ===
                    "edit-dashboard") && (
                  <WidgetDescription
                    section_index={section_index}
                    widget_index={widget_index}
                    widget_id={widget_id}
                    widgetData={widgetData}
                    setOpenPopoverWidgetDesc={setOpenPopoverWidgetDesc}
                    openPopoverWidgetDesc={openPopoverWidgetDesc}
                  />
                )}
              </div>
            )}
        </div>
      )}
    </>
  );
};

export default React.memo(WidgetHeader, isEqual);
